function salutRelatedReveal(root) {
  if (typeof initializeScrollAnimationTrigger !== 'function') return;
  if (!root.querySelector('.scroll-trigger')) return;
  initializeScrollAnimationTrigger(root);
}

function salutRelatedWatch(element) {
  const observer = new MutationObserver(() => {
    if (!element.children.length) return;
    observer.disconnect();
    salutRelatedReveal(element);
  });
  observer.observe(element, { childList: true });
}

document.querySelectorAll('.section-related-products product-recommendations').forEach((element) => {
  if (element.children.length) {
    salutRelatedReveal(element);
  } else {
    salutRelatedWatch(element);
  }
});
